/**
 * Socket constants for the VMailbox widget.
 */

export const VMAILBOX_SOCKET_CONSTANTS = {
	TYPE: 'request',
	SERVICE: 'astimax-states',
	METHOD_SUBSCRIBE: 'subscribe',
	METHOD_UNSUBSCRIBE: 'unsubscribe',
	EVENT_TYPE: 'voiceMailboxState',
	EMIT_REQUEST: 'request',
	LISTEN_ON_RESPONSE: 'response',
	LISTEN_ON_EVENT: 'event',
	LISTEN_UPDATE: 'voiceMailboxStateUpdate',
	LISTEN_DELETE: 'voiceMailboxStateDelete',
	LISTEN_MESSAGE_DELETE: 'voiceMailboxMessageStateDelete',
	VERSION: '1.0',
} as const;

// ─────────────────────────────────────────────────────────────
// Event shapes (from astimax-states socket API)
// ─────────────────────────────────────────────────────────────

export interface VoiceMailboxStateUpdateItem {
	id: number;
	number: string;
	name: string;
	messages: {
		new: number;
		oldM: number;
	};
}

export interface VoiceMailboxStateUpdateEvent {
	id: string;
	type: 'event';
	service: 'astimax-states';
	method: 'voiceMailboxStateUpdate';
	payload: VoiceMailboxStateUpdateItem[];
	timestamp: string;
	metadata: { amsaType: 'VoiceMailboxStateUpdateEvent' };
}

export interface VoiceMailboxStateDeleteEvent {
	id: string;
	type: 'event';
	service: 'astimax-states';
	method: 'voiceMailboxStateDelete';
	payload: { id: number };
	timestamp: string;
	metadata: { amsaType: 'VoiceMailboxStateDeleteEvent' };
}

export interface VoiceMailboxMessageStateDeleteEvent {
	id: string;
	type: 'event';
	service: 'astimax-states';
	method: 'voiceMailboxMessageStateDelete';
	payload: { id: number; mailboxId: number };
	timestamp: string;
	metadata: { amsaType: 'VoiceMailboxMessageStateDeleteEvent' };
}
